<p-dialog
  [visible]="isVisible()"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '80vw' }"
  [style]="{ width: '40rem' }"
  [showHeader]="false"
  contentStyleClass="p-6!"
  footerStyleClass="pb-6! px-6!">
  <div class="flex flex-col gap-6">
    <div class="flex flex-col items-center gap-4">
      <div class="flex items-center justify-center h-12 w-12 bg-primary-100 rounded-full border border-primary-200 shrink-0">
        <i class="fas fa-clock text-xl! leading-none! text-primary-400"></i>
      </div>
      <h3 class="font-semibold text-xl text-center m-0">Session Timeout</h3>
    </div>
    <p class="leading-normal text-center p-0 m-0">For your security, you will be automatically logged out in:</p>
    <p class="text-2xl text-center font-bold text-primary-400 font-mono mb-3">
      {{ formatTime(timeRemaining()) }}
    </p>
  </div>
  <ng-template #footer>
    <div class="flex w-full gap-4">
      <button pButton [outlined]="true" class="flex-1" (click)="logout()">
        <span pButtonLabel>Log Out Now</span>
      </button>
      <button pButton class="flex-1" (click)="extendSession()">
        <span pButtonLabel>Continue Session</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
